// extracted by mini-css-extract-plugin
module.exports = {"header-equipment-icon":"HeaderEquipmentIcon_header-equipment-icon__JgZvC","header-equipment-icon--size":"HeaderEquipmentIcon_header-equipment-icon--size__KoVeC"};